import { getSessionId } from "../adapters/ApexAdapter";
import { useIsAuthenticated } from '@azure/msal-react';
import { useMsal } from '@azure/msal-react';

const useSessionId = () => {
    const { accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    if(isAuthenticated && accounts.length > 0){
        return accounts[0].localAccountId;
    }
    return getSessionId();
};

export { useSessionId };
export default useSessionId;